export default __webpack_public_path__ + "static/media/stats1.44d5876c.svg";